import { render, staticRenderFns } from "./IconSvgLegislative.vue?vue&type=template&id=ca39f06c&scoped=true&"
import script from "./IconSvgLegislative.vue?vue&type=script&lang=js&"
export * from "./IconSvgLegislative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca39f06c",
  null
  
)

export default component.exports